/* istanbul ignore file */
import { DropDownFilter } from 'framework/list';
import { EmployeeTypeDropdown } from 'domain/shared/employee';
import { EnumDropdownProps } from 'framework/form';

const EmployeeTypeFilter = (props: Omit<EnumDropdownProps, 'options'>) => {
  return (
    <DropDownFilter {...props}>
      <EmployeeTypeDropdown {...props} />
    </DropDownFilter>
  );
};

export default EmployeeTypeFilter;
